import PropTypes from 'prop-types'
import React from 'react'

import CtaLink from '../CtaLink'

import './styles.css'

// The ask (SPEC-052 FR-8, SPEC-053 FR-5): its own full-bleed band, centered
// and self-contained — heading, one line of body, the CTA, and the
// reassurance beneath it. Proof lives in its own section (Testimonials);
// Pedro's review: these are two sections, not one.
function TrialBlock({
  heading,
  body = '',
  ctaLabel = 'Start my 7-day free trial',
  ctaUrl = '/subscriptions/plans',
  reassurance = ''
}) {
  return (
    <section className="lm-trial">
      <div className="lm-trial__inner wrapper">
        <h2 className="lm-trial__title">{heading}</h2>
        {body && <p className="lm-trial__subtitle">{body}</p>}
        <CtaLink to={ctaUrl} className="btn -orange lm-trial__cta">
          {ctaLabel}
        </CtaLink>
        {reassurance && (
          // the serializer sends one "·"-separated string; the deck renders
          // it as individual check items
          <ul className="lm-trial__reassurance">
            {reassurance.split('·').map((item) => (
              <li key={item.trim()}>{item.trim()}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  )
}

TrialBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  reassurance: PropTypes.string
}

export default TrialBlock
